import React from "react";
import PropTypes from "prop-types";
import { getConfig } from "../../config";
import { renderAgreementStatus } from "./userProfileHelpers";
import { AccountField, ContactNameField, ContactEmailField, PhoneField, PrivacyPolicyField } from "./FormFields";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningIcon from "@mui/icons-material/Warning";
import CampaignIcon from "@mui/icons-material/Campaign";

export const ProfileFormSection = ({
  profileSection,
  account,
  businessReadOnly,
  companyName,
  isOemAdmin,
  handleFieldChange,
  inputCompNameErrMsg,
  profileReadOnly,
  corporateContactName,
  inputCrpNameErrMsg,
  companyWebsite,
  inputCompWebsiteErrMsg,
  corporateContactEmail,
  inputCrpEmailErrMsg,
  registrationCourt,
  inputRegistrationCourt,
  phoneNumber,
  setPhoneNumber,
  companyRegNumber,
  inputRegNumberErrMsg,
  readOnlyValue,
  privacyPolicy,
  inputPrivacyLinkErrMsg,
  showSaveFlag,
  showBusinessFlag,
  agreementDetails,
  agreementDetailsData,
  agreementStatus,
  handleViewDeveloperAgreement,
  setCompanyName,
  setCorporateContactName,
  setCompanyWebsite,
  setCorporateContactEmail,
  setRegistrationCourt,
  setCompanyRegNumber,
  setPrivacyPolicy
}) => {
  const isIdpLogin = sessionStorage.getItem("idpLogin") === "true";
  const isSeller = getConfig().REACT_APP_PORTAL === "seller";

  return (
    <>
      <div className="accountControlCls">
        <AccountField
          profileSection={profileSection}
          account={account}
          businessReadOnly={businessReadOnly}
          companyName={companyName}
          isOemAdmin={isOemAdmin}
          handleFieldChange={handleFieldChange(setCompanyName, "Company Name")}
          inputCompNameErrMsg={inputCompNameErrMsg}
          profileReadOnly={profileReadOnly}
        />
        <ContactNameField
          profileSection={profileSection}
          isIdpLogin={isIdpLogin}
          profileReadOnly={profileReadOnly}
          corporateContactName={corporateContactName}
          handleContactNameChange={handleFieldChange(setCorporateContactName, "Corporate Contact Name")}
          inputCrpNameErrMsg={inputCrpNameErrMsg}
          businessReadOnly={businessReadOnly}
          companyWebsite={companyWebsite}
          handleWebsiteChange={handleFieldChange(setCompanyWebsite, "Company Website")}
          inputCompWebsiteErrMsg={inputCompWebsiteErrMsg}
          isOemAdmin={isOemAdmin}
        />
      </div>
      <div className="accountControlCls">
        <ContactEmailField
          profileSection={profileSection}
          isIdpLogin={isIdpLogin}
          profileReadOnly={profileReadOnly}
          corporateContactEmail={corporateContactEmail}
          handleEmailChange={handleFieldChange(setCorporateContactEmail, "Corporate Contact Email")}
          inputCrpEmailErrMsg={inputCrpEmailErrMsg}
          businessReadOnly={businessReadOnly}
          registrationCourt={registrationCourt}
          handleCourtChange={handleFieldChange(setRegistrationCourt, "Registration Court")}
          inputRegistrationCourt={inputRegistrationCourt}
        />
        <PhoneField
          profileSection={profileSection}
          isIdpLogin={isIdpLogin}
          profileReadOnly={profileReadOnly}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          businessReadOnly={businessReadOnly}
          companyRegNumber={companyRegNumber}
          handleRegNumberChange={handleFieldChange(setCompanyRegNumber, "Registration Number")}
          inputRegNumberErrMsg={inputRegNumberErrMsg}
        />
      </div>
      {profileSection && (
        <div className="accountControlCls">
          <PrivacyPolicyField
            readOnlyValue={readOnlyValue}
            privacyPolicy={privacyPolicy}
            handlePrivacyChange={handleFieldChange(setPrivacyPolicy, "Privacy Policy")}
            inputPrivacyLinkErrMsg={inputPrivacyLinkErrMsg}
            isOemAdmin={isOemAdmin}
            isIdpLogin={isIdpLogin}
          />
        </div>
      )}
      {profileSection && !isIdpLogin && isSeller && !(showSaveFlag || showBusinessFlag) && (
        <div className="agreementMsg">
          <div className="developerAgreementTxt">
            Developer Agreement <span style={{ color: "red" }}>*</span>
          </div>
          {renderAgreementStatus(agreementDetails, agreementDetailsData, agreementStatus, VerifiedIcon, WarningIcon, CampaignIcon)}
          <button
            type="button"
            className="viewAgreementCls"
            onClick={handleViewDeveloperAgreement}
          >
            View Developer Agreement
          </button>
        </div>
      )}
    </>
  );
};

ProfileFormSection.propTypes = {
  profileSection: PropTypes.bool,
  account: PropTypes.string,
  businessReadOnly: PropTypes.bool,
  companyName: PropTypes.string,
  isOemAdmin: PropTypes.bool,
  handleFieldChange: PropTypes.func.isRequired,
  inputCompNameErrMsg: PropTypes.string,
  profileReadOnly: PropTypes.bool,
  corporateContactName: PropTypes.string,
  inputCrpNameErrMsg: PropTypes.string,
  companyWebsite: PropTypes.string,
  inputCompWebsiteErrMsg: PropTypes.string,
  corporateContactEmail: PropTypes.string,
  inputCrpEmailErrMsg: PropTypes.string,
  registrationCourt: PropTypes.string,
  inputRegistrationCourt: PropTypes.string,
  phoneNumber: PropTypes.string,
  setPhoneNumber: PropTypes.func.isRequired,
  companyRegNumber: PropTypes.string,
  inputRegNumberErrMsg: PropTypes.string,
  readOnlyValue: PropTypes.bool,
  privacyPolicy: PropTypes.string,
  inputPrivacyLinkErrMsg: PropTypes.string,
  showSaveFlag: PropTypes.bool,
  showBusinessFlag: PropTypes.bool,
  agreementDetails: PropTypes.object,
  agreementDetailsData: PropTypes.object,
  agreementStatus: PropTypes.bool,
  handleViewDeveloperAgreement: PropTypes.func.isRequired,
  setCompanyName: PropTypes.func.isRequired,
  setCorporateContactName: PropTypes.func.isRequired,
  setCompanyWebsite: PropTypes.func.isRequired,
  setCorporateContactEmail: PropTypes.func.isRequired,
  setRegistrationCourt: PropTypes.func.isRequired,
  setCompanyRegNumber: PropTypes.func.isRequired,
  setPrivacyPolicy: PropTypes.func.isRequired
};
